import React from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Query } from 'react-apollo';
import { get } from 'lodash-es';
import GetCMSPostsForAdminQuery from '../../../operations/queries/GetCMSPostsForAdminQuery';
import { EditPostForm } from './EditPostForm';
import { handleRequestError } from '../../../constants/errorCodes';
import { ROUTE_TO_ADMIN_NEWS_PAGE } from '../../../constants/routes';
import { POST_TYPE_NEWS } from '../../../constants/business';

export const AdminEditPostPage = props => {
  const dispatch = useDispatch();
  const params = useParams();
  const postId = parseInt(params.postId, 10);

  return (
    <Query
      query={GetCMSPostsForAdminQuery}
      variables={{ filter: { id: postId, type: POST_TYPE_NEWS } }}
      onError={error => handleRequestError(error, dispatch)}
    >
      {({ loading, data }) => {
        if (loading || !data) {
          return null;
        }

        if (data.getPosts.length < 1) {
          return <Redirect to={ROUTE_TO_ADMIN_NEWS_PAGE} />;
        }

        const post = get(data, 'getPosts.posts[0]', null);

        return <EditPostForm post={post} />;
      }}
    </Query>
  );
};
